const animationEnterHero = (container) => {
  const header = container.querySelector('.header-hero');
  const hero = container.querySelector('.featured-hero img');
  const title = container.querySelector('.hero-title-effect');
  const subtitle = container.querySelector('.hero-subtitle-effect');

  const tl = gsap.timeline({
    onStart: function () {
      Foundation.reflow($(container), 'interchange');
    },
    defaults: {
      duration: 0.9,
      ease: 'power2.inOut',
    },
  });

  tl.to(header, { duration: 0.5, autoAlpha: 1 })
    .from(hero, {
      duration: 1.5,
      scale: 1.05,
      ease: 'expoScale( 1.05, 1 )',
    }, '>-0.2')
    .from(
      title,
      {
        y: +100,
        autoAlpha: 0,
      },
      '>-0.5'
    )
    .from(
      subtitle,
      {
        y: +100,
        autoAlpha: 0,
      },
      '>-0.2'
    );

  return tl;
};

export default animationEnterHero;
